module.exports = __webpack_public_path__ + "img/logo_navbar.d35f88c5.png";